import {fetchWithToken} from '@hublot-io/core-api/client'
import moment from 'moment'

import CalculUtils from '@/utils/calculUtils'

import config from '../utils/apiUtils'



export const CadencierService = {
  getCadencier(date = moment().format('YYYY-MM-DD'), source) {
    return fetchWithToken(`${config().cadencierService}/diff/?date=${date}&source=${source}`, {method: 'GET'})
      .then(response => response.json())
  },
  getAllCadencier(date = moment().format('YYYY-MM-DD'), source) {
    return fetchWithToken(`${config().cadencierService}/diff/?date=${date}&all=true&source=${source}`, {method: 'GET'})
      .then(response => response.json())
  },
  achats(days) {
    return CalculUtils.round(days.reduce((total, day) => {
      if (day.achat === 0 || day.vente === 0 || isNaN(day.vente) || isNaN(day.achat)) { return total }
      return total + CalculUtils.achats(day.achat, day.quantite)
    }, 0))
  },
  vente(days) {
    return CalculUtils.round(days.reduce((total, day) => {
      if (day.achat === 0 || day.vente === 0 || isNaN(day.vente) || isNaN(day.achat)) { return total }
      return total + CalculUtils.venteHT(day.vente, day.quantite, day.casse, day.transformation, day.freinte)
    }, 0))
  },
  venteTTC(days) {
    return CalculUtils.round(days.reduce((total, day) => {
      if (day.achat === 0 || day.vente === 0 || isNaN(day.vente) || isNaN(day.achat)) { return total }
      return total + CalculUtils.vente(day.vente, day.quantite, day.casse, day.freinte, day.transformation)
    }, 0))
  },
  casse(days) {
    return CalculUtils.round(days.reduce((total, day) => {
      if (day.achat === 0 || day.vente === 0) { return total }
      return total + parseFloat(day.casse)
    }, 0))
  },
  stock(days) {
    return CalculUtils.sumList(days.map(day => ({reel: day.reel * day.achat})), 'reel')
  },
  casse(days) {
    return CalculUtils.sumList(days.map(day => ({casse: day.casse * day.achat})), 'casse')
  },
  margeValeur(achats, vente) {
    return CalculUtils.round(CalculUtils.margeValeurHT(achats, vente))
  },
  margePourcentage(achats, vente) {
    return CalculUtils.margePourcentageHT(achats, vente)
  },
  compare(a, b) {
    if (a.value.code && b.value.code) {
      if (a.value.code.text < b.value.code.text) {
        return -1
      }
      if (a.value.code.text > b.value.code.text) {
        return 1
      }
    }
    return 0
  }
}
